import { Component, ComponentInterface, h, Host, JSX, Prop } from '@stencil/core';

/**
 * @slot - element to display in as the tab's content
 */
@Component({
  tag: 'wb-tab-content',
  styleUrl: './tab-content.scss',
  shadow: true,
})
export class TabContentComponent implements ComponentInterface {
  /** Name of the tab. Must match name of a wb-tab */
  @Prop({ reflect: true })
  public name!: string;

  /** @internal apply to render element, set by wb-tabs */
  @Prop({ reflect: true })
  public selected: boolean = false;

  public render(): JSX.Element {
    return (
      <Host class="wb-tab-content" role="tabpanel">
        <slot />
      </Host>
    );
  }
}
